import React, { useContext, useEffect, useRef } from "react";
import "../css/paysuccess.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faXmark } from "@fortawesome/free-solid-svg-icons";
import { Link, useSearchParams } from "react-router-dom";
import { CartContext } from "./CartContext";

const PaySuccess = () => {
  const [searchParams] = useSearchParams();
  const succeeded = searchParams.get("state") !== "cancel";
  const { clearCart } = useContext(CartContext);
  const cartCleared = useRef(false);

  useEffect(() => {
    if (succeeded && !cartCleared.current) {
      cartCleared.current = true;
      clearCart();
    }
  }, [clearCart, succeeded]);
  return (
    <>
      <div className="successDiv">
        <div className="success-container">
          <div className="modal-content">
            <div className={`checkmark-circle ${succeeded ? "" : "cancel-circle"}`}>
              <FontAwesomeIcon icon={succeeded ? faCheck : faXmark} />
            </div>
            <h1>{succeeded ? "Payment received" : "Payment cancelled"}</h1>
            <p>{succeeded ? "Your order has been received and is being reviewed." : "No payment was completed. Your cart has been kept so you can try again."}</p>
            <Link className="payment-result-link" to={succeeded ? "/shop" : "/checkout"}>{succeeded ? "Continue shopping" : "Return to checkout"}</Link>
          </div>
        </div>
      </div>
    </>
  );
};

export default PaySuccess;
